module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title_media":"附照片/短片","title_image":"附加照片","add_image":"附加照片","add_video":"附加视频","disclaimer":"个人信息泄露（CCTV/黑匣子）、名誉损害、著作权等侵权视频，可能根据使用条款及相关法律受到制裁。"}}')
  delete Component.options._Ctor
}
